const usefulLinks = {
  "Гендерний профіль громади":
    "https://drive.google.com/drive/folders/1FUXVun20ha2scfD-uQalf64zSBVdMuSQ",
  "Про забезпечення рівних прав та можливостей жінок та чоловіків":
    "https://zakon.rada.gov.ua/laws/show/2866-15#Text",
  "Про запобігання та протидію домашньому насильству":
    "https://zakon.rada.gov.ua/laws/show/2229-19#Text",
  "Про затвердження Національного плану дій з виконання Резолюції Ради Безпеки ООН 1325 «Жінки, мир, безпека» на період до 2025 року":
    "https://zakon.rada.gov.ua/laws/show/1544-2020-%D1%80#Text",
  "Стратегія впровадження гендерної рівності у сфері освіти до 2030 року":
    "https://mon.gov.ua/storage/app/media/news/2023/03/16/Strateh.vprovadzh.hendern.rivn.u.sferi.osvity.do.2030.roku.16.03.2023.pdf",
  "Європейська хартія рівності жінок і чоловіків у житті місцевих громад":
    "https://hcj.gov.ua/sites/default/files/field/3._yevropeyska_hartiya_rivnosti.pdf",
  "Про затвердження Методичних рекомендацій щодо впровадження таа застосування гендерно орієнтованого підходу в бюджетному процесі":
    "https://zakon.rada.gov.ua/rada/show/v0001201-19#Text",
  "Словник фемінітивів":
    "https://drive.google.com/drive/folders/1BxYNHIKrYXuo-EQMhRGaEPpLmPedP_lG",
};

export { usefulLinks };
